module.exports = __webpack_public_path__ + "static/media/futLogo.5e5dccdd.svg";